module.exports = __webpack_public_path__ + "img/contact_record_video.d61bd9b4.png";